"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEP = exports.RETIREMENT_PLAN = exports.IRA = exports.PENSION_PLAN = exports.RETIREMENT_403B = exports.RETIREMENT_401K = exports.GOVERNMENT_BOND = exports.JOINT_VENTURE = exports.PARTNERSHIP = exports.INCORPORATED_BUSINESS = exports.UNINCORPORATED_BUSINESS = exports.LICENSE = exports.FRANCHISE = exports.MISC_INTELLECTUAL_PROPERTY = exports.TRADE_SECRET = exports.TRADEMARK = exports.COPYRIGHT = exports.PATENT = exports.TRUST = exports.COLLEGE_SAVINGS_ACCOUNT = exports.ANNUITY = exports.MUTUAL_FUND = exports.CORPORATE_BOND = exports.BOND = exports.STOCK = exports.FINANCIAL_INTERESTS = exports.ABLE_ACCOUNT = exports.SAVINGS_ACCOUNT = exports.SAFE_DEPOSIT_BOX = exports.OTHER_FINANCIAL_ACCOUNT = exports.MONEY_MARKET = exports.MINOR_CHILDS_PROPERTY = exports.MINOR_CHILDS_EARNINGS = exports.INVESTMENT_ACCOUNT = exports.HEALTH_SAVINGS_ACCOUNT = exports.ESCROW = exports.DEPOSIT = exports.CHECKING_ACCOUNT = exports.CERTIFICATE_OF_DEPOSIT = exports.CASH = exports.BROKERAGE = exports.FINANCIAL_ACCOUNTS = exports.MOBILE_HOME = exports.ATV = exports.WATERCRAFT = exports.AIRCRAFT = exports.TRAILER = exports.AUTOMOBILE = exports.TIMESHARE = exports.STORAGE_UNIT = exports.SINGLE_FAMILY = exports.MULTI_FAMILY = exports.MANUFACTURED = exports.LAND = exports.INVESTMENT = exports.EXEMPT_PROPERTY = exports.COOP = exports.BURIAL_GROUND = exports.WEDDING_RINGS = exports.WATCH = exports.VCR = exports.UNIFORMS_REQUIRED_BY_LAW = exports.UNIFORMS = exports.TV = exports.TITLE_TO_BOAT = exports.TEACHING_EQUIPMENT = exports.SPORTS_OR_HOBBY_EQUIPMENT = exports.RADIO = exports.PROFIT_OR_RENT_FROM_PROPERTY = exports.PERSONAL_ANIMALS = exports.MUSICAL_INSTRUMENT = exports.MILITARY_EQUIPMENT = exports.NOTARY_PUBLIC_SEAL = exports.JEWELRY = exports.HOUSING_AUTHORITY_PROPERTY = exports.HOUSEHOLD = exports.HEIRLOOM = exports.HEALTHAID = exports.FOOD_AND_FUEL = exports.FIREARMS = exports.FAMILY_PHOTOS = exports.ELECTRONICS = exports.COMPUTER = exports.COLLECTIBLES = exports.CLOTHES = exports.BOOK = exports.BICYCLE = exports.ARTWORK = exports.ANTIQUE = exports.AMMUNITION = exports.OTHER = exports.FISHING_SUPPLIES = exports.FISHING_PROPERTY = exports.FISHING_EQUIPMENT = exports.FARMING_SUPPLIES = exports.FARMING_PROPERTY = exports.FARMING_EQUIPMENT = exports.WATER_RIGHTS = exports.CROPS = exports.FARM_ANIMALS = void 0;
exports.BUSINESS_ENTITY = exports.PARTNERSHIP_PROPERTY = exports.FRATERNAL_BENEFIT = exports.SOLE_PROPRIETOR = exports.LIMITED_LIABILITY = exports.BUSINESS_ASSETS = exports.BUSINESS_VEHICLE = exports.BUSINESS_PROPERTY = exports.TOOLS_OF_TRADE = exports.OFFICE_EQUIPMENT = exports.MACHINERY = exports.LIQUOR_PERMIT = exports.INVENTORY = exports.CUSTOMER_LISTS = exports.ACCOUNTS_RECEIVABLE = exports.OWED_OTHER = exports.UNPAID_SOCIAL_SECURITY_BENEFITS = exports.UNPAID_WORKERS_COMPENSATION = exports.UNPAID_DISABILITY_INSURANCE = exports.UNPAID_DISABILITY_BENEFITS = exports.UNPAID_WAGES = exports.SOLD_EXEMPT_PROPERTY_PROCEEDS = exports.CONTINGENT_CLAIM = exports.CLAIM = exports.INTEREST_FROM_DEATH = exports.BONUSES = exports.WAGES_OUT_OF_STATE = exports.WAGES = exports.PROPERTY_SETTLEMENT = exports.DIVORCE_SETTLEMENT = exports.CHILD_SUPPORT = exports.MAINTENANCE = exports.ALIMONY = exports.TAX_CREDIT = exports.TAX_REFUND = exports.FINANCIAL_OWED = exports.TUITION_CREDITS = exports.RESTITUTION_PAYMENTS = exports.OCCUPATIONAL_DISEASE_COMPENSATION = exports.HAZARDOUS_OCCUPATION_INJURY_AWARD = exports.PROCEEDS_FROM_HEALTH_OR_DIABILITY_INSURANCE_CLAIM = exports.DAMAGED_PROPERTY_PROCEEDS = exports.LOSS_OF_FUTURE_EARNINGS_COMPENSATION = exports.WORKERS_COMP = exports.PERSONAL_INJURY_COMPENSATION = exports.WRONGFUL_DEATH_AWARD = exports.CRIME_VICTIM_COMPENSATION = exports.FINANCIAL_AWARDS = exports.PUBLIC_ASSISTANCE = exports.FINANCIAL_BENEFITS = exports.INSURANCE_PLAN = exports.WAGES_OF_DESERTING_FAMILY = exports.WAGES_OF_DECEASED_STATE_EMPLOYEE = exports.ENDOWMENT_CONTRACT_BENEFITS = exports.PROCEEDS_FOR_EXEMPT_PROPERTY = exports.RETAIL_INSTALLMENT_SALES = exports.OTHER_RETIREMENT_PLAN = exports.KEOGH = void 0; // Agriculture

var FARM_ANIMALS = 'farm_animals';
exports.FARM_ANIMALS = FARM_ANIMALS;
var CROPS = 'crops';
exports.CROPS = CROPS;
var WATER_RIGHTS = 'water_rights';
exports.WATER_RIGHTS = WATER_RIGHTS;
var FARMING_EQUIPMENT = 'farming_equipment';
exports.FARMING_EQUIPMENT = FARMING_EQUIPMENT;
var FARMING_PROPERTY = 'farming_property';
exports.FARMING_PROPERTY = FARMING_PROPERTY;
var FARMING_SUPPLIES = 'farming_supplies';
exports.FARMING_SUPPLIES = FARMING_SUPPLIES;
var FISHING_EQUIPMENT = 'fishing_equipment';
exports.FISHING_EQUIPMENT = FISHING_EQUIPMENT;
var FISHING_PROPERTY = 'fishing_property';
exports.FISHING_PROPERTY = FISHING_PROPERTY;
var FISHING_SUPPLIES = 'fishing_supplies';
exports.FISHING_SUPPLIES = FISHING_SUPPLIES;
var OTHER = 'other'; // Personal

exports.OTHER = OTHER;
var AMMUNITION = 'ammunition';
exports.AMMUNITION = AMMUNITION;
var ANTIQUE = 'antique';
exports.ANTIQUE = ANTIQUE;
var ARTWORK = 'artwork';
exports.ARTWORK = ARTWORK;
var BICYCLE = 'bicycle';
exports.BICYCLE = BICYCLE;
var BOOK = 'book';
exports.BOOK = BOOK;
var CLOTHES = 'clothes';
exports.CLOTHES = CLOTHES;
var COLLECTIBLES = 'collectibles';
exports.COLLECTIBLES = COLLECTIBLES;
var COMPUTER = 'computer';
exports.COMPUTER = COMPUTER;
var ELECTRONICS = 'electronics';
exports.ELECTRONICS = ELECTRONICS;
var FAMILY_PHOTOS = 'family_photos';
exports.FAMILY_PHOTOS = FAMILY_PHOTOS;
var FIREARMS = 'firearms';
exports.FIREARMS = FIREARMS;
var FOOD_AND_FUEL = 'food_and_fuel';
exports.FOOD_AND_FUEL = FOOD_AND_FUEL;
var HEALTHAID = 'healthaid';
exports.HEALTHAID = HEALTHAID;
var HEIRLOOM = 'heirloom';
exports.HEIRLOOM = HEIRLOOM;
var HOUSEHOLD = 'household';
exports.HOUSEHOLD = HOUSEHOLD;
var HOUSING_AUTHORITY_PROPERTY = 'housing_authority_property'; // Indiana

exports.HOUSING_AUTHORITY_PROPERTY = HOUSING_AUTHORITY_PROPERTY;
var JEWELRY = 'jewelry';
exports.JEWELRY = JEWELRY;
var NOTARY_PUBLIC_SEAL = 'notary_public_seal';
exports.NOTARY_PUBLIC_SEAL = NOTARY_PUBLIC_SEAL;
var MILITARY_EQUIPMENT = 'military_equipment';
exports.MILITARY_EQUIPMENT = MILITARY_EQUIPMENT;
var MUSICAL_INSTRUMENT = 'musical_instrument';
exports.MUSICAL_INSTRUMENT = MUSICAL_INSTRUMENT;
var PERSONAL_ANIMALS = 'personal_animals';
exports.PERSONAL_ANIMALS = PERSONAL_ANIMALS;
var PROFIT_OR_RENT_FROM_PROPERTY = 'profit_or_rent_from_property';
exports.PROFIT_OR_RENT_FROM_PROPERTY = PROFIT_OR_RENT_FROM_PROPERTY;
var RADIO = 'radio';
exports.RADIO = RADIO;
var SPORTS_OR_HOBBY_EQUIPMENT = 'sports_or_hobby_equipment';
exports.SPORTS_OR_HOBBY_EQUIPMENT = SPORTS_OR_HOBBY_EQUIPMENT;
var TEACHING_EQUIPMENT = 'teaching_equipment';
exports.TEACHING_EQUIPMENT = TEACHING_EQUIPMENT;
var TITLE_TO_BOAT = 'title_to_boat';
exports.TITLE_TO_BOAT = TITLE_TO_BOAT;
var TV = 'tv';
exports.TV = TV;
var UNIFORMS = 'uniforms';
exports.UNIFORMS = UNIFORMS;
var UNIFORMS_REQUIRED_BY_LAW = 'uniforms_required_by_law';
exports.UNIFORMS_REQUIRED_BY_LAW = UNIFORMS_REQUIRED_BY_LAW;
var VCR = 'vcr';
exports.VCR = VCR;
var WATCH = 'watch';
exports.WATCH = WATCH;
var WEDDING_RINGS = 'wedding_rings'; // export const OTHER = 'other';
// export const OTHER = 'other';
// Property

exports.WEDDING_RINGS = WEDDING_RINGS;
var BURIAL_GROUND = 'burial_ground';
exports.BURIAL_GROUND = BURIAL_GROUND;
var COOP = 'coop';
exports.COOP = COOP;
var EXEMPT_PROPERTY = 'exempt_property';
exports.EXEMPT_PROPERTY = EXEMPT_PROPERTY;
var INVESTMENT = 'investment';
exports.INVESTMENT = INVESTMENT;
var LAND = 'land';
exports.LAND = LAND;
var MANUFACTURED = 'manufactured';
exports.MANUFACTURED = MANUFACTURED;
var MULTI_FAMILY = 'multi_family';
exports.MULTI_FAMILY = MULTI_FAMILY;
var SINGLE_FAMILY = 'single_family';
exports.SINGLE_FAMILY = SINGLE_FAMILY;
var STORAGE_UNIT = 'storage_unit';
exports.STORAGE_UNIT = STORAGE_UNIT;
var TIMESHARE = 'timeshare'; // export const OTHER = 'other';
// Vehicle

exports.TIMESHARE = TIMESHARE;
var AUTOMOBILE = 'automobile';
exports.AUTOMOBILE = AUTOMOBILE;
var TRAILER = 'trailer';
exports.TRAILER = TRAILER;
var AIRCRAFT = 'aircraft';
exports.AIRCRAFT = AIRCRAFT;
var WATERCRAFT = 'watercraft';
exports.WATERCRAFT = WATERCRAFT;
var ATV = 'atv';
exports.ATV = ATV;
var MOBILE_HOME = 'mobile_home'; // export const OTHER = 'other';
// FINANCIAL
// FINANCIAL - ACCOUNTS

exports.MOBILE_HOME = MOBILE_HOME;
var FINANCIAL_ACCOUNTS = 'financial_accounts';
exports.FINANCIAL_ACCOUNTS = FINANCIAL_ACCOUNTS;
var BROKERAGE = 'brokerage';
exports.BROKERAGE = BROKERAGE;
var CASH = 'cash';
exports.CASH = CASH;
var CERTIFICATE_OF_DEPOSIT = 'certificate_of_deposit';
exports.CERTIFICATE_OF_DEPOSIT = CERTIFICATE_OF_DEPOSIT;
var CHECKING_ACCOUNT = 'checking_account';
exports.CHECKING_ACCOUNT = CHECKING_ACCOUNT;
var DEPOSIT = 'deposit';
exports.DEPOSIT = DEPOSIT;
var ESCROW = 'escrow';
exports.ESCROW = ESCROW;
var HEALTH_SAVINGS_ACCOUNT = 'health_savings_account';
exports.HEALTH_SAVINGS_ACCOUNT = HEALTH_SAVINGS_ACCOUNT;
var INVESTMENT_ACCOUNT = 'investment_account';
exports.INVESTMENT_ACCOUNT = INVESTMENT_ACCOUNT;
var MINOR_CHILDS_EARNINGS = 'minor_childs_earnings';
exports.MINOR_CHILDS_EARNINGS = MINOR_CHILDS_EARNINGS;
var MINOR_CHILDS_PROPERTY = 'minor_childs_property';
exports.MINOR_CHILDS_PROPERTY = MINOR_CHILDS_PROPERTY;
var MONEY_MARKET = 'money_market';
exports.MONEY_MARKET = MONEY_MARKET;
var OTHER_FINANCIAL_ACCOUNT = 'other_financial_account';
exports.OTHER_FINANCIAL_ACCOUNT = OTHER_FINANCIAL_ACCOUNT;
var SAFE_DEPOSIT_BOX = 'safe_deposit_box';
exports.SAFE_DEPOSIT_BOX = SAFE_DEPOSIT_BOX;
var SAVINGS_ACCOUNT = 'savings_account';
exports.SAVINGS_ACCOUNT = SAVINGS_ACCOUNT;
var ABLE_ACCOUNT = 'able_account'; // FINANCIAL - INTERESTS

exports.ABLE_ACCOUNT = ABLE_ACCOUNT;
var FINANCIAL_INTERESTS = 'financial_interests';
exports.FINANCIAL_INTERESTS = FINANCIAL_INTERESTS;
var STOCK = 'stock';
exports.STOCK = STOCK;
var BOND = 'bond';
exports.BOND = BOND;
var CORPORATE_BOND = 'corporate_bond';
exports.CORPORATE_BOND = CORPORATE_BOND;
var MUTUAL_FUND = 'mutual_fund';
exports.MUTUAL_FUND = MUTUAL_FUND;
var ANNUITY = 'annuity';
exports.ANNUITY = ANNUITY;
var COLLEGE_SAVINGS_ACCOUNT = 'college_savings_account';
exports.COLLEGE_SAVINGS_ACCOUNT = COLLEGE_SAVINGS_ACCOUNT;
var TRUST = 'trust';
exports.TRUST = TRUST;
var PATENT = 'patent';
exports.PATENT = PATENT;
var COPYRIGHT = 'copyright';
exports.COPYRIGHT = COPYRIGHT;
var TRADEMARK = 'trademark';
exports.TRADEMARK = TRADEMARK;
var TRADE_SECRET = 'trade_secret';
exports.TRADE_SECRET = TRADE_SECRET;
var MISC_INTELLECTUAL_PROPERTY = 'misc_intellectual_property';
exports.MISC_INTELLECTUAL_PROPERTY = MISC_INTELLECTUAL_PROPERTY;
var FRANCHISE = 'franchise';
exports.FRANCHISE = FRANCHISE;
var LICENSE = 'license';
exports.LICENSE = LICENSE;
var UNINCORPORATED_BUSINESS = 'unincorporated_business';
exports.UNINCORPORATED_BUSINESS = UNINCORPORATED_BUSINESS;
var INCORPORATED_BUSINESS = 'incorporated_business';
exports.INCORPORATED_BUSINESS = INCORPORATED_BUSINESS;
var PARTNERSHIP = 'partnership';
exports.PARTNERSHIP = PARTNERSHIP;
var JOINT_VENTURE = 'joint_venture';
exports.JOINT_VENTURE = JOINT_VENTURE;
var GOVERNMENT_BOND = 'government_bond';
exports.GOVERNMENT_BOND = GOVERNMENT_BOND;
var RETIREMENT_401K = 'retirement_401k';
exports.RETIREMENT_401K = RETIREMENT_401K;
var RETIREMENT_403B = 'retirement_403b';
exports.RETIREMENT_403B = RETIREMENT_403B;
var PENSION_PLAN = 'pension_plan';
exports.PENSION_PLAN = PENSION_PLAN;
var IRA = 'ira';
exports.IRA = IRA;
var RETIREMENT_PLAN = 'retirement_plan';
exports.RETIREMENT_PLAN = RETIREMENT_PLAN;
var SEP = 'sep';
exports.SEP = SEP;
var KEOGH = 'keogh';
exports.KEOGH = KEOGH;
var OTHER_RETIREMENT_PLAN = 'OTHER_RETIREMENT_PLAN';
exports.OTHER_RETIREMENT_PLAN = OTHER_RETIREMENT_PLAN;
var RETAIL_INSTALLMENT_SALES = 'retail_installment_sales';
exports.RETAIL_INSTALLMENT_SALES = RETAIL_INSTALLMENT_SALES;
var PROCEEDS_FOR_EXEMPT_PROPERTY = 'proceeds_for_exempt_property';
exports.PROCEEDS_FOR_EXEMPT_PROPERTY = PROCEEDS_FOR_EXEMPT_PROPERTY;
var ENDOWMENT_CONTRACT_BENEFITS = 'endowment_contract_benefits';
exports.ENDOWMENT_CONTRACT_BENEFITS = ENDOWMENT_CONTRACT_BENEFITS;
var WAGES_OF_DECEASED_STATE_EMPLOYEE = 'wages_of_deceased_state_employee';
exports.WAGES_OF_DECEASED_STATE_EMPLOYEE = WAGES_OF_DECEASED_STATE_EMPLOYEE;
var WAGES_OF_DESERTING_FAMILY = 'wages_of_deserting_family';
exports.WAGES_OF_DESERTING_FAMILY = WAGES_OF_DESERTING_FAMILY;
var INSURANCE_PLAN = 'insurance_plan'; // NOTE: has tertiary
// FINANCIAL - BENEFITS

exports.INSURANCE_PLAN = INSURANCE_PLAN;
var FINANCIAL_BENEFITS = 'financial_benefits';
exports.FINANCIAL_BENEFITS = FINANCIAL_BENEFITS;
var PUBLIC_ASSISTANCE = 'public_assistance'; // NOTE: has tertiary
// FINANCIAL - AWARDS

exports.PUBLIC_ASSISTANCE = PUBLIC_ASSISTANCE;
var FINANCIAL_AWARDS = 'financial_awards';
exports.FINANCIAL_AWARDS = FINANCIAL_AWARDS;
var CRIME_VICTIM_COMPENSATION = 'crime_victim_compensation';
exports.CRIME_VICTIM_COMPENSATION = CRIME_VICTIM_COMPENSATION;
var WRONGFUL_DEATH_AWARD = 'wrongful_death_award';
exports.WRONGFUL_DEATH_AWARD = WRONGFUL_DEATH_AWARD;
var PERSONAL_INJURY_COMPENSATION = 'personal_injury_compensation';
exports.PERSONAL_INJURY_COMPENSATION = PERSONAL_INJURY_COMPENSATION;
var WORKERS_COMP = 'workers_comp';
exports.WORKERS_COMP = WORKERS_COMP;
var LOSS_OF_FUTURE_EARNINGS_COMPENSATION = 'loss_of_future_earnings_compensation';
exports.LOSS_OF_FUTURE_EARNINGS_COMPENSATION = LOSS_OF_FUTURE_EARNINGS_COMPENSATION;
var DAMAGED_PROPERTY_PROCEEDS = 'damaged_property_proceeds';
exports.DAMAGED_PROPERTY_PROCEEDS = DAMAGED_PROPERTY_PROCEEDS;
var PROCEEDS_FROM_HEALTH_OR_DIABILITY_INSURANCE_CLAIM = 'proceeds_from_health_or_disability_insurance_claim';
exports.PROCEEDS_FROM_HEALTH_OR_DIABILITY_INSURANCE_CLAIM = PROCEEDS_FROM_HEALTH_OR_DIABILITY_INSURANCE_CLAIM;
var HAZARDOUS_OCCUPATION_INJURY_AWARD = 'hazardous_occupation_injury_award';
exports.HAZARDOUS_OCCUPATION_INJURY_AWARD = HAZARDOUS_OCCUPATION_INJURY_AWARD;
var OCCUPATIONAL_DISEASE_COMPENSATION = 'occupational_disease_compensation';
exports.OCCUPATIONAL_DISEASE_COMPENSATION = OCCUPATIONAL_DISEASE_COMPENSATION;
var RESTITUTION_PAYMENTS = 'restitution_payments';
exports.RESTITUTION_PAYMENTS = RESTITUTION_PAYMENTS;
var TUITION_CREDITS = 'tuition_credits'; // FINANCIAL - OWED

exports.TUITION_CREDITS = TUITION_CREDITS;
var FINANCIAL_OWED = 'financial_owed';
exports.FINANCIAL_OWED = FINANCIAL_OWED;
var TAX_REFUND = 'tax_refund'; // NOTE: federal, state, local

exports.TAX_REFUND = TAX_REFUND;
var TAX_CREDIT = 'tax_credit';
exports.TAX_CREDIT = TAX_CREDIT;
var ALIMONY = 'alimony';
exports.ALIMONY = ALIMONY;
var MAINTENANCE = 'maintenance';
exports.MAINTENANCE = MAINTENANCE;
var CHILD_SUPPORT = 'child_support';
exports.CHILD_SUPPORT = CHILD_SUPPORT;
var DIVORCE_SETTLEMENT = 'divorce_settlement';
exports.DIVORCE_SETTLEMENT = DIVORCE_SETTLEMENT;
var PROPERTY_SETTLEMENT = 'property_settlement';
exports.PROPERTY_SETTLEMENT = PROPERTY_SETTLEMENT;
var WAGES = 'wages';
exports.WAGES = WAGES;
var WAGES_OUT_OF_STATE = 'wages_out_of_state';
exports.WAGES_OUT_OF_STATE = WAGES_OUT_OF_STATE;
var BONUSES = 'bonuses';
exports.BONUSES = BONUSES;
var INTEREST_FROM_DEATH = 'interest_from_death';
exports.INTEREST_FROM_DEATH = INTEREST_FROM_DEATH;
var CLAIM = 'claim';
exports.CLAIM = CLAIM;
var CONTINGENT_CLAIM = 'contingent_claim';
exports.CONTINGENT_CLAIM = CONTINGENT_CLAIM;
var SOLD_EXEMPT_PROPERTY_PROCEEDS = 'sold_exempt_property_proceeds';
exports.SOLD_EXEMPT_PROPERTY_PROCEEDS = SOLD_EXEMPT_PROPERTY_PROCEEDS;
var UNPAID_WAGES = 'unpaid_wages'; // NOTE: Separated out from owed_other for exemption logic?

exports.UNPAID_WAGES = UNPAID_WAGES;
var UNPAID_DISABILITY_BENEFITS = 'unpaid_disability_benefits';
exports.UNPAID_DISABILITY_BENEFITS = UNPAID_DISABILITY_BENEFITS;
var UNPAID_DISABILITY_INSURANCE = 'unpaid_disability_insurance';
exports.UNPAID_DISABILITY_INSURANCE = UNPAID_DISABILITY_INSURANCE;
var UNPAID_WORKERS_COMPENSATION = 'unpaid_workers_compensation';
exports.UNPAID_WORKERS_COMPENSATION = UNPAID_WORKERS_COMPENSATION;
var UNPAID_SOCIAL_SECURITY_BENEFITS = 'unpaid_social_security_benefits';
exports.UNPAID_SOCIAL_SECURITY_BENEFITS = UNPAID_SOCIAL_SECURITY_BENEFITS;
var OWED_OTHER = 'owed_other'; // BUSINESS - ASSSETS

exports.OWED_OTHER = OWED_OTHER;
var ACCOUNTS_RECEIVABLE = 'accounts_receivable';
exports.ACCOUNTS_RECEIVABLE = ACCOUNTS_RECEIVABLE;
var CUSTOMER_LISTS = 'customer_lists';
exports.CUSTOMER_LISTS = CUSTOMER_LISTS;
var INVENTORY = 'inventory';
exports.INVENTORY = INVENTORY;
var LIQUOR_PERMIT = 'liquor_permit';
exports.LIQUOR_PERMIT = LIQUOR_PERMIT;
var MACHINERY = 'machinery';
exports.MACHINERY = MACHINERY;
var OFFICE_EQUIPMENT = 'office_equipment';
exports.OFFICE_EQUIPMENT = OFFICE_EQUIPMENT;
var TOOLS_OF_TRADE = 'tools_of_trade';
exports.TOOLS_OF_TRADE = TOOLS_OF_TRADE;
var BUSINESS_PROPERTY = 'business_property';
exports.BUSINESS_PROPERTY = BUSINESS_PROPERTY;
var BUSINESS_VEHICLE = 'business_vehicle'; // export const OTHER = 'other';

exports.BUSINESS_VEHICLE = BUSINESS_VEHICLE;
var BUSINESS_ASSETS = 'business_assets'; // Category Constant
// BUSINESS - ENTITY
// export const UNINCORPORATED_BUSINESS = 'unincorporated_business';
// export const INCORPORATED_BUSINESS = 'incorporated_business';
// export const PARTNERSHIP = 'partnership';

exports.BUSINESS_ASSETS = BUSINESS_ASSETS;
var LIMITED_LIABILITY = 'limited_liability'; // export const JOINT_VENTURE = 'joint_venture';

exports.LIMITED_LIABILITY = LIMITED_LIABILITY;
var SOLE_PROPRIETOR = 'sole_proprietor';
exports.SOLE_PROPRIETOR = SOLE_PROPRIETOR;
var FRATERNAL_BENEFIT = 'fraternal_benefit';
exports.FRATERNAL_BENEFIT = FRATERNAL_BENEFIT;
var PARTNERSHIP_PROPERTY = 'partnership_property';
exports.PARTNERSHIP_PROPERTY = PARTNERSHIP_PROPERTY;
var BUSINESS_ENTITY = 'business_entity'; // Category Constant

exports.BUSINESS_ENTITY = BUSINESS_ENTITY;